"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _percentPart = _interopRequireDefault(require("@deosite/helpers/percentPart"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var __jsx = _react["default"].createElement;
var PriceProgress = function PriceProgress(props) {
  var currentPrice = props.currentPrice,
    limitPrice = props.limitPrice,
    progressColor = props.progressColor;
  var translations = {
    freeDelivery: (0, _langLibrary["default"])("Free delivery"),
    toFreeDelivery: (0, _langLibrary["default"])("to free standard shipping")
  };
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var amountToFreeDelivery = __jsx(_Box["default"], {
    as: "span"
  }, priceWithCurrency(limitPrice - currentPrice), __jsx(_Box["default"], {
    as: "span"
  }, "\xA0", translations.toFreeDelivery));
  var percentWidth = currentPrice >= limitPrice ? 100 : (0, _percentPart["default"])(currentPrice, limitPrice);
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      textAlign: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      flexBasis: "100%",
      font: "body2",
      color: "main"
    }
  }, currentPrice >= limitPrice ? translations.freeDelivery : amountToFreeDelivery), __jsx(_Box["default"], {
    sx: {
      flexBasis: "100%",
      minHeight: "12px",
      maxHeight: "12px",
      borderColor: "neutral500",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "7px",
      my: "s6",
      p: "s1",
      bg: "neutral300",
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "8px",
      backgroundColor: progressColor || "active",
      borderRadius: "7px",
      position: "absolute",
      zIndex: "2",
      top: "1px",
      left: "1px",
      width: percentWidth + "%",
      transition: "width 0.2s ease-out"
    }
  })));
};
var _default = PriceProgress;
exports["default"] = _default;